// extracted by mini-css-extract-plugin
module.exports = {"dummy":"global__dummy___3Htvy"};